import sendRequest from "@/libs/sendRequest";

export const monitoreo = {
    namespaced: true,

    state: {
        dashboardData: null,
        lastUpdated: null,
        loading: false,
        error: null
    },
    
    getters: {
        getItems: (state) => state.dashboardData?.data || {},
        getLastUpdate: (state) => state.lastUpdated,
        isLoading: (state) => state.loading,
        getError: (state) => state.error
    },
    
    mutations: {
        setDashboardData: (state, payload) => {
            state.dashboardData = payload;
            state.lastUpdated = new Date();
        },
        setLoading: (state, payload) => {
            state.loading = payload;
        },
        setError: (state, payload) => {
            state.error = payload;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    
    actions: {
        list: async ({ commit, rootGetters }) => {
            commit('setLoading', true);
            commit('clearError');
            
            try {
                const custom_headers = rootGetters.getHeaders;
                
                const response = await sendRequest(
                    `administrator/heishop/monitoring/dashboard`, 
                    'GET', 
                    null, 
                    null, 
                    null, 
                    custom_headers
                );

                if (response.data) {
                    commit('setDashboardData', response);
                } else {
                    commit('setError', response.errors || 'Error al cargar los datos');
                }
            } catch (error) {
                commit('setError', error.message || 'Error en la solicitud');
                console.error('Error en la solicitud:', error);
            } finally {
                commit('setLoading', false);
            }
        }
    }
};